import { API_URLS } from "../constants";
import apiClient from "./interceptor";
import { encryptAES } from './crypto';

export const login = async (loginParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const encryptedData = await encryptAES(loginParams.password, secretKey);
        const loginPayloadParams = {
            user_name: loginParams.user_name,
            iv_hex: encryptedData.iv,
            encrypted_hex: encryptedData.encrypted,
        };

        const response = await apiClient.post(API_URLS.AUTH.LOGIN, loginPayloadParams);
        return response.data;
    } catch (error) {
        console.error("Error logging in:", error);
        throw error;
    }
};

export const changePassword = async (changePasswordParams) => {
    try {
        const secretKey = process.env.REACT_APP_SECRET_KEY || "";
        const oldEncryptedData = await encryptAES(changePasswordParams.old_password, secretKey);

        const changePasswordPayloadParams = {
            user_name: changePasswordParams.user_name,
            iv_hex_old: oldEncryptedData.iv,
            encrypted_hex_old: oldEncryptedData.encrypted,
            new_password: changePasswordParams.new_password,
        };

        const response = await apiClient.post(
            API_URLS.AUTH.CHANGE_PASSWORD,
            changePasswordPayloadParams
        );

        return response.data;
    } catch (error) {
        console.error("Error changing password:", error);
        throw error;
    }
};

export const getCropsAndVarieties = async () => {
    try {
        const response = await apiClient.get(`${API_URLS.CROP_VARIETY_MACHINE.GET_CROPS_AND_VARIETIES}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

// get all machine
export const getAllMachines = async () => {
    try {
        const response = await apiClient.get(`${API_URLS.CROP_VARIETY_MACHINE.GET_MACHINES}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getScans = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.SCANS.GET_SCANS, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getSubScans = async (scan_id) => {
    try {
        const response = apiClient.get(`${API_URLS.SCANS.GET_SUB_SCANS}/${scan_id}`)
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getScanDetails = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.SCANS.GET_SCAN_DETAILS, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getReviewScanDetails = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.SCANS.GET_REVIEW_SCAN_DETAILS, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getScanPdf = async (scanId, subScanId) => {
    try {
        const payload = { "scan_id": scanId };
        if (subScanId) {
            payload["sub_scan_id"] = subScanId;
        }
        const response = await apiClient.post(
            API_URLS.SCANS.GET_SCAN_PDF,
            payload,
            { responseType: 'blob' }
        );
        return response
    } catch (error) {
        console.error(error);
        return error
    }
};

export const createReviewedKernal = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.REVIEW_KERNEL.CREATE_REVIEW_KERNEL, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}
export const getReviewedKernal = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.REVIEW_KERNEL.GET_REVIEW_KERNEL, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getRevieweHistory = async (payload) => {
    try {
        const response = await apiClient.post(API_URLS.REVIEW_KERNEL.GET_REVIEW_HISTORY, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getImageFromCanvas = async (imgUrl, boundingBox) => {
    const fullImageElement = new Image();
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    boundingBox = JSON.parse(boundingBox);
    const boxWidth = boundingBox[2] - boundingBox[0];
    const boxHeight = boundingBox[3] - boundingBox[1];

    return new Promise((resolve, reject) => {
        fullImageElement.onload = () => {
            try {
                canvas.width = boxWidth;
                canvas.height = boxHeight;
                context.drawImage(
                    fullImageElement,
                    boundingBox[0],
                    boundingBox[1],
                    boxWidth,
                    boxHeight,
                    0,
                    0,
                    boxWidth,
                    boxHeight
                );
                const croppedImage = canvas.toDataURL("image/png");
                resolve(croppedImage);
            } catch (error) {
                reject(error);
            }
        };

        fullImageElement.onerror = (error) => {
            reject(error);
        };

        fullImageElement.src = imgUrl;
        fullImageElement.crossOrigin = "anonymous";
    });
};

export const getCanvasImgData = async (imgurl, boundingBox) => {
    const canvas2d = document.createElement("canvas");
    const context = canvas2d.getContext("2d");
    context.fillStyle = "red";
    context.strokeStyle = "#FF0000";
    context.lineWidth = 20;

    const paintImage = () => {
        return new Promise((resolve) => {
            const imageObj = new Image();
            imageObj.onload = () => {
                const imgWidth = imageObj.width;
                const imgHeight = imageObj.height;

                canvas2d.width = imgWidth;
                canvas2d.height = imgHeight;
                context.strokeStyle = "#FF0000";
                context.lineWidth = 8;
                context.drawImage(imageObj, 0, 0, imgWidth, imgHeight);

                const parsedBox = JSON.parse(boundingBox);
                const boxWidth = parsedBox[2] - parsedBox[0];
                const boxHeight = parsedBox[3] - parsedBox[1];

                context.strokeRect(parsedBox[0], parsedBox[1], boxWidth, boxHeight);

                resolve(true);
            };

            imageObj.src = imgurl;
            imageObj.crossOrigin = "anonymous";
        });
    };

    const isDrawn = await paintImage();

    if (isDrawn) {
        return canvas2d.toDataURL("image/png");
    }
};

export const getCanvasImgDataForArray = async (imgurl, items) => {
    const canvas2d = document.createElement("canvas");
    const context = canvas2d.getContext("2d");
    context.fillStyle = "red";
    context.strokeStyle = "#FF0000";
    context.lineWidth = 20;

    const imObjFunction = () => {
        return new Promise((resolve) => {
            const imageObj = new Image();
            function paintImage() {
                const imgWidth = imageObj.width;
                const imgHeight = imageObj.height;

                canvas2d.width = imgWidth;
                canvas2d.height = imgHeight;
                context.strokeStyle = "#FF0000";
                context.lineWidth = 8;
                context.drawImage(imageObj, 0, 0, imgWidth, imgHeight);

                for (let i = 0; i < items.length; i++) {
                    const box = items[i];
                    const boxX = box[0];
                    const boxY = box[1];
                    const boxWidth = box[2] - box[0];
                    const boxHeight = box[3] - box[1];

                    context.strokeRect(boxX, boxY, boxWidth, boxHeight);
                }

                resolve(true);
            }
            imageObj.src = imgurl;
            imageObj.crossOrigin = "anonymous";
            imageObj.addEventListener("load", paintImage, false);
        });
    };

    const isDrawn = await imObjFunction();

    if (isDrawn) {
        return canvas2d.toDataURL("image/png");
    }
};

export const getAllUsers = async () => {
    try {
        const response = await apiClient.get(`${API_URLS.USER.GET_USERS}`);
        return response
    } catch (error) {
        console.log(error);
    }
}

export const getAllImages = async (payload) => {
    try {
        const response = await apiClient.post(`${API_URLS.SCANS.GET_SCAN_IMAGES}`, payload);
        return response
    } catch (error) {
        console.log(error);
    }
}
